import * as React from 'react';
import Base, { Props as BaseProps } from '../Base/Base';

export interface Props extends BaseProps {}

/**
 * The header row that holds the TableHeaderCell components. Should be
 * a direct descendant of the TableHeader component.
 */
const TableHeaderRow: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Base { ...props }
        Component="tr"
        className="Table__header-row" />
  );
};

export default TableHeaderRow;
